module.exports = __webpack_public_path__ + "arrow-right.png?a024e5eb7ff67ee3723b15f8de6ef29c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.png
// module id = 549
// module chunks = 0